export default __webpack_public_path__ + "static/media/platelet.3382452b.png";